export default __webpack_public_path__ + "static/media/telegramexpo1-01.15ecddc2.png";